import { defaultTextSize, defaultTextColor } from '../defaults';
export const extractTextStyles = (customStyle, fallbackStyle) => {
    return {
        color: customStyle.color || fallbackStyle.color || defaultTextColor,
        fontFamily: customStyle.fontFamily || fallbackStyle.fontFamily || 'Roboto,Arial',
        fontSize: customStyle.fontSize || fallbackStyle.fontSize || defaultTextSize,
        fontStyle: customStyle.fontStyle || fallbackStyle.fontStyle || 'normal',
        fontWeight: customStyle.fontWeight || fallbackStyle.fontWeight || 'normal',
        textDecoration: customStyle.textDecoration || fallbackStyle.textDecoration || 'none',
    };
};
//# sourceMappingURL=extract-text-styles.js.map